import { defaultTheme } from "common/components/ui";
import { useMedia } from "react-use";

export const useMobile = () => useMedia(`(max-width: ${defaultTheme.breakpoints.SM})`);
